function SuspenseContent(){
    return(
        <div className="w-full p-4 h-screen text-gray-300 dark:text-gray-200 bg-base-100">
            Loading...
        </div>
    )
}

export default SuspenseContent